import React, { Component } from 'react'
import { Carousel } from "react-bootstrap";
import { Helmet } from 'react-helmet';
import BannerCarouselButton from "./banner-carousel-button";

import './banner-carousel.css';

class BannerCarousel extends Component {
  render() {
    const { carousels, carouselSpeed, isLargeBanner } = this.props;

    return (
      <div>
        <Carousel interval={carouselSpeed * 1000} indicators={carousels.length > 1} controls={carousels.length > 1} className='banner-carousel-container'>
          {carousels.map((carousel, key) => (
            <Carousel.Item key={key}>
              <Helmet>
                <script>
                  {
                    `(function (custom_carousel_content_id) {
                    ${carousel.javascript_tag_attributes.content}
                  }('custom_carousel_content_id_${carousel.id}'))`
                  }
                </script>
                <style type='text/css'>
                  {
                    carousel.css_tag_attributes.content && carousel.css_tag_attributes.content
                      .replace('custom_carousel_content_id', `#custom_carousel_content_id_${carousel.id}`)
                  }
                </style>
              </Helmet>
              {carousel.image_uid.endsWith('.mp4') ? (
                <video className="carousel-image video" loop autoPlay>
                  <source src={carousel.link.image}
                          type="video/mp4"></source>
                  Sorry, your browser doesn't support videos.
                </video>
              ) : (
                <img className="carousel-image" alt={carousel.title || 'carousel-background'}
                     src={carousel.link.image}/>
              )}
              <Carousel.Caption className="carousel-caption-banner">
                <div id={`custom_carousel_content_id_${carousel.id}`}></div>
                <div className="carousel-details-container">
                  <div className="carousel-text-container">
                    {carousel['title'] &&
                      <h1 className='carousel-title' style={{ color: carousel['text_color']}}>{carousel.title || ' '}</h1>
                    }
                    <p className='carousel-details' style={{ color: carousel['text_color']}}>{carousel.text || ' '}</p>
                  </div>
                  {carousel.button_label &&
                    <BannerCarouselButton
                      buttonColor={carousel.button_color}
                      buttonTextColorWhenHover={carousel.button_text_color_when_hover}
                      buttonLink={carousel.button_link}
                      buttonLabel={carousel.button_label}
                    />
                  }
                </div>
              </Carousel.Caption>
            </Carousel.Item>
          ))}
        </Carousel>
      </div>
    )
  }
}

export default BannerCarousel;



// WEBPACK FOOTER //
// ./src/components/home/banner-carousel/banner-carousel.jsx